<template>
  <div class="box-container width100 height100">
    <MultiSplitPane
      split="horizontal"
      height=""
      resizerWidth="5px"
      classes="custom-resizer"
    >
      <Pane id="panel-left" :initWidth="'100%'">
        <template v-slot:content>
          <div class="ma-2">
            <table-data
              :loading="loading"
              :items="items"
              :nameSelected="nameSelected"
              @getDetail="getDetail"
            />
          </div>
        </template>
      </Pane>
      <Pane id="panel-right" :initWidth="'0%'">
        <template v-slot:content>
          <div class="ma-2">
            <progress-announcement :total="total" :item="itemSelected" />
            <pie-next-checkpoint :item="itemSelected" @nextClick="nextClick" />
            <table-next-checkpoint
              :item="itemSelected"
              @nextClick="nextClick"
            />
          </div>
        </template>
      </Pane>
    </MultiSplitPane>
  </div>
</template>

<script>
import _ from 'lodash'
import apiInsight from '@/apis/insight'

import { MultiSplitPane, Pane } from 'vue-multi-split-pane'

import TableData from './table_data'

import ProgressAnnouncement from './progress_announcement'
import PieNextCheckpoint from './pie_next_checkpoint'
import TableNextCheckpoint from './table_next_checkpoint'

export default {
  props: {
    search: Object,
    count: Number
  },
  components: {
    TableData,
    ProgressAnnouncement,
    PieNextCheckpoint,
    TableNextCheckpoint,
    MultiSplitPane,
    Pane
  },
  watch: {
    count: {
      immediate: true,
      handler() {
        this.getCheckpoint()
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      itemSelected: {},
      total: 1,
      nameSelected: ''
    }
  },
  methods: {
    async getCheckpoint() {
      try {
        this.loading = true
        this.total = 1

        const response = await apiInsight.getCheckpoint(this.search)
        const { data } = response

        if (data.length > 0) {
          const total = _.find(data, o => {
            return o.name === 'Start'
          })

          if (total) {
            this.total = total.visit
          }

          for (const obj of data) {
            obj.percent_visit = parseFloat(
              (obj.visit * 100) / this.total
            ).toFixed(2)

            const exit = _.find(obj.child, o => {
              return o.name === 'Ended By User'
            })

            obj.exit = exit ? exit.visit : 0
            obj.percent_exit = parseFloat(
              (obj.exit * 100) / this.total
            ).toFixed(2)
          }
        }
        this.items = data
        this.loading = false
      } catch {
      } finally {
        this.$emit('closeDialogLoading', null)
      }
    },
    getDetail(item) {
      setTimeout(() => {
        this.itemSelected = item

        const panelRight = document.getElementById('panel-right')

        const boxContanier = document.getElementsByClassName('box-container')[0]
        if (panelRight.offsetWidth < boxContanier.offsetWidth / 2)
          panelRight.style.minWidth = boxContanier.offsetWidth / 2 + 'px'

        const panelRightContent = document
          .getElementById('panel-right')
          .getElementsByClassName('content')[0]
        panelRightContent.scrollTop = 0
      }, 200)
    },
    nextClick(name) {
      this.nameSelected = name
    }
  }
}
</script>

<style lang="scss" scoped></style>
